import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.funkprotokoll-vorlage-detail-admin';
import * as api from '../../../clients/veranstaltungen';

@Injectable()
export class VeranstaltungenFunkprotokollVorlageDetailAdminEffects {

    FunkprotokollVorlageDetailAdmin$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_FUNKPROTOKOLL_VORLAGE_DETAIL_ADMIN),
        mergeMap((x: ac.GetFunkprotokollVorlageDetailAdminAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getFunkprotokollVorlageDetailAdmin(x.id).pipe(
                map((result: any) => {
                    return new ac.GetFunkprotokollVorlageDetailAdminErfolgreichAction(result, x.id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetFunkprotokollVorlageDetailAdminFehlerAction(error, x.id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.FunkprotokollVorlageQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.FunkprotokollVorlageQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.FunkprotokollVorlageQueryService);
        }
        return this.service;
    }
}
